module.exports = __webpack_public_path__ + "img/welcome-image.678d67e4.png";